import Cart from './components/Cart';

const CartPage = () => {
  return (
    <div>
      <Cart />
    </div>
  );
};

export default CartPage;
